module.exports = "assets/d3f65bf976df8f70c28d4f68ce62b07f.jpg";